import { axios } from '@Root/API'

export const paginateReply = (id, params) => {
  return axios.get(`notes/applications/${id}/children`, { params })
}
